export default __webpack_public_path__ + "static/media/datasheets-bg.5ed83345.jpg";